import { gql } from '@apollo/client';
const GET_CURRENT_TENANT_SIZINGS = gql `
  query GetCurrentTenantSizings($first: Int = 20, $after: String = "") {
    me {
      id
      currentTenant {
        id
        sizeStandards(first: $first, after: $after) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              name
              canNameBeUpdated
              canBeRemoved
              isActive
              isDefault
              sizes {
                edges {
                  node {
                    id
                    name
                    canNameBeUpdated
                    canBeRemoved
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_SIZINGS;
